// extracted by mini-css-extract-plugin
module.exports = {"mobileRootLayout":"nP_K7"};